import barba from "@barba/core";
import barbaInit from "./functions/barba";
import { initAnimations } from "./functions/animations";
import { initApplicationForms } from "./ApplicationForm";
import { initAudioControls } from "./VideoControls";
import { initBlobsSection } from "./hooks/BlobsSection";
import { initContactForms } from "./ContactForm";
import { initMainMenu } from "./functions/mainMenu";
import { initPostsSection } from "./PostsSection";
// @ts-ignore
import Carousel from "./Carousel.js";
// if ("scrollRestoration" in history) {
//   history.scrollRestoration = "auto";
// }
function addScrollIntoView(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const firstContent = document.querySelector("section.content");
    firstContent.scrollIntoView({
        behavior: "smooth",
    });
}
function jumpToContent() {
    const jumpIcon = document.querySelector("#jumpToContent");
    if (jumpIcon) {
        jumpIcon.addEventListener("click", addScrollIntoView);
    }
}
window.gtag = window.gtag || {};
window.bootstrap = window.bootstrap || {};
// window.bootstrap.Dropdown = Dropdown;
window.bootstrap.Carousel = Carousel;
// window.bootstrap.Collapse = Collapse;
function docReady(fn) {
    if (document.readyState === "complete" ||
        document.readyState === "interactive") {
        setTimeout(fn);
    }
    else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}
docReady(() => {
    let popState = {
        pop: false,
        scroll: {},
    };
    function handleHistory(event) {
        const states = event.state.states;
        popState = Object.assign({}, states[0]);
        popState.pop = true;
        window.scrollTo(Object.assign({}, popState.scroll));
    }
    window.addEventListener("popstate", handleHistory);
    barbaInit();
    initMainMenu();
    jumpToContent();
    const langSwitch = document.querySelector("a.language-switcher");
    if (langSwitch) {
        langSwitch.addEventListener("click", (event) => {
            event.stopPropagation();
        });
    }
    const mobileMenu = document.querySelector("#mobileMenu");
    const html = document.querySelector("html");
    const toggle = () => {
        mobileMenu.classList.toggle("show");
        html.classList.toggle("no-scroll");
    };
    const close = () => {
        mobileMenu.classList.remove("show");
        html.classList.remove("no-scroll");
    };
    const toggleButton = document.querySelector(".navbar-toggler");
    toggleButton.addEventListener("click", toggle);
    if (document.referrer) {
        const { host } = new URL(document.referrer);
        if (host !== document.location.host)
            window.sessionStorage.setItem("referrer", host);
        // window.gtag("event", "sessionReferrer", {
        //   host: host,
        // });
    }
    initAnimations();
    initPostsSection();
    initContactForms();
    initApplicationForms();
    initAudioControls();
    initBlobsSection();
    const video = document.querySelector("#oimVideoHeader");
    if (video && video.clientHeight)
        video.play();
    barba.hooks.after(() => {
        close();
        if (!popState.pop)
            window.scrollTo({ top: 0 });
        popState.pop = false;
        jumpToContent();
        initAnimations();
        initPostsSection();
        initContactForms();
        initApplicationForms();
        initAudioControls();
        initBlobsSection();
        const video = document.querySelector("#oimVideoHeader");
        if (video && video.clientHeight)
            video.play();
    });
    // barba.hooks.enter(initAnimations);
    // barba.prevent.checkHref;
});
